import { motion } from 'motion/react'

/**
 * Reusable stagger animation container
 * Animates children with a delay between each
 */
export const StaggerContainer = ({
  children,
  staggerDelay = 0.1,
  delayChildren = 0.1,
  className = '',
  as = 'div',
  ...props
}) => {
  // Check for reduced motion preference
  const prefersReducedMotion = typeof window !== 'undefined'
    ? window.matchMedia('(prefers-reduced-motion: reduce)').matches
    : false

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: prefersReducedMotion ? 0 : staggerDelay,
        delayChildren: prefersReducedMotion ? 0 : delayChildren
      }
    }
  }

  // Use motion[as] to support different element types (div, form, section, etc.)
  const Component = motion[as]

  return (
    <Component
      initial="hidden"
      whileInView="visible"
      viewport={{ once: true, margin: "-100px" }}
      variants={containerVariants}
      className={className}
      {...props}
    >
      {children}
    </Component>
  )
}

// Child item variant for use with StaggerContainer
export const staggerItemVariants = {
  hidden: { opacity: 0, y: 20 },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: [0.25, 0.46, 0.45, 0.94]
    }
  }
}
